import { Box, Typography, Card, CardContent, Tabs, Tab } from '@mui/material';
import { useState } from 'react';
import PasskeysPanel from './PasskeysPanel';
import PreferencesPanel from './PreferencesPanel';
import WorkspacePanel from './WorkspacePanel';
import { useAuthStore } from '../../stores/auth.store';

export default function SettingsPage() {
  const isAdmin = useAuthStore((s) => s.user?.role === 'admin');
  const [tab, setTab] = useState(0);

  // Workspace is admin-only (its edit is), and Notifications is dropped until it has content.
  const tabs = [
    { label: 'General', panel: <PreferencesPanel /> },
    ...(isAdmin ? [{ label: 'Workspace', panel: <WorkspacePanel /> }] : []),
    { label: 'Security', panel: <PasskeysPanel /> },
  ];
  const active = Math.min(tab, tabs.length - 1);

  return (
    <Box>
      <Typography variant="h4" fontWeight={600} sx={{ mb: 3 }}>
        Settings
      </Typography>

      <Tabs value={active} onChange={(_, v) => setTab(v)} sx={{ mb: 2 }}>
        {tabs.map((t) => <Tab key={t.label} label={t.label} />)}
      </Tabs>

      <Card>
        <CardContent>{tabs[active].panel}</CardContent>
      </Card>
    </Box>
  );
}
